import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PackageSafariDetails from "./PackageSafariDetails";
import apiCall, { apiCall2 } from "../../Api/api";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { useAuth } from "provider/AuthContext";
import { handleError } from "components/Api/handleError";

const PackageView = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { packSlug } = useParams();
  const cleanSlug = decodeURIComponent(packSlug);
  const { packageViewData, packageViewLoading, pageIndexUserComment, safariPackagesDispatch } = useSafariPackagesContext();

  useEffect(() => {
    let isCancelled = false;
    const fetchPackageView = async () => {
      try {
        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_LOADING",
          payload: true,
        });

        const response = await apiCall({
          url: `package/${cleanSlug}`,
          method: "GET",
        });
        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response.data;

        if (apiData?.errors) {
          safariPackagesDispatch({
            type: "SET_PACKAGE_VIEW_ERROR",
            payload: apiData.errors,
          });
          console.error("API returned errors:", apiData.errors);
          return;
        }

        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_DETAILS",
          payload: apiData.data,
        });


        const commentsUrl = apiData?.data?.urls?.comments;
        safariPackagesDispatch({ type: "SET_PACKAGE_VIEW_COMMENTS_URL", payload: commentsUrl });

      } catch (error) {
        console.error("Safari detail fetch error:", error);
        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_ERROR",
          payload: "Network or server error occurred.",
        });
        handleError(error, logout, navigate);
      } finally {
        safariPackagesDispatch({
          type: "SET_PACKAGE_VIEW_LOADING",
          payload: false,
        });
      }
    };

    if (cleanSlug) {
      fetchPackageView();
    }

    return () => {
      isCancelled = true;
    };
  }, [cleanSlug]);


  // --- 2. Fetch Comments when commentsUrl is set ---
  useEffect(() => {
    if (!packageViewData?.urls.comments) return;

    let isCancelled = false;

    const fetchAllComments = async () => {
      try {

        const response = await apiCall2({
          url: `${packageViewData?.urls.comments}?page=${pageIndexUserComment}&pageSize=10&sort=-created_at`,
          method: "GET",
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status: ${response.status}`);
        }


        const data = response.data.comments?.data || [];
        const summary = response?.data?.comments?.summary;

        if (pageIndexUserComment === 1) {
          safariPackagesDispatch({ type: "SET_PACKAGE_VIEW_USERS_COMMENTS", payload: data });
        } else {
          safariPackagesDispatch({
            type: "APPEND_PACKAGE_USERS_COMMENTS_DATA",
            payload: data,
          });
        }

        safariPackagesDispatch({
          type: "SF_USER_COMMENTS_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      }
    };
    if (packageViewData?.urls.comments) {
      fetchAllComments();
    }
    return () => {
      isCancelled = true;
    };
  }, [packageViewData?.urls.comments, pageIndexUserComment]);

  return <PackageSafariDetails safariPackages={packageViewData} />;
};

export default PackageView;
